export const VERIFY_SESSION_PERIOD = 10 * 60 * 1000; // 10 min in ms
export const START_UP_DELAY = 0;
